import { useState, useRef } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import { Toast } from "primereact/toast";
const AlldatatblListPage = (props) => {
		const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		},
		sent_total: {
			tagTitle: "Sent Total",
			value: '',
			valueType: 'single',
			options: [],
		},
		templeteid: {
			tagTitle: "Templeteid",
			value: '',
			valueType: 'single',
			options: [],
		},
		states: {
			tagTitle: "States",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "Send Mail",
			command: (event) => { app.navigate(`/sendMail(data.id)`) }
		},
		{
			label: "View",
			command: (event) => { app.navigate(`/alldatatbl/view/${data.id}`) },
			icon: "pi pi-eye"
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/alldatatbl/edit/${data.id}`) },
			icon: "pi pi-pencil"
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.id) },
			icon: "pi pi-trash"
		}
	]
		return (<Menubar className="p-0 " model={items} />);
	}
	function IdTemplate(data){
		if(data){
			return (
				<Link to={`/alldatatbl/view/${data.id}`}> { data.id }</Link>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-alldatatbl`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<MultiDelete />
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
const toast = useRef(null);
const API_BASE = process.env.REACT_APP_API_PATH; // e.g. https://yourdomain.com/api
function ActionButton(data){
    const items = [
    {
        label: "Send Mail",
        command: () => sendMail(data.id), // ✅ call sendMail directly
    },
    {
        label: "View",
        command: (event) => { app.navigate(`/alldatatbl/view/${data.id}`) },
        icon: "pi pi-eye"
    },
    {
        label: "Edit",
        command: (event) => { app.navigate(`/alldatatbl/edit/${data.id}`) },
        icon: "pi pi-pencil"
    },
    {
        label: "Delete",
        command: (event) => { deleteItem(data.id) },
        icon: "pi pi-trash"
    }
    ]
    return (<Menubar className="p-0 " model={items} />);
}
const sendMail = async (id) => {
    try {
        const res = await fetch(`${API_BASE}email/send/${id}`, { method: "POST" });
        if (res.ok) {
            toast.current.show({
                severity: "success",
                summary: "Email Sent",
                detail: `Email sent successfully for ID ${id}`,
            });
            } else {
            const text = await res.text();
            toast.current.show({
                severity: "error",
                summary: "Error Sending Email",
                detail: text,
            });
        }
        } catch (err) {
        toast.current.show({
            severity: "error",
            summary: "Network Error",
            detail: err.message,
        });
    }
};
  const [progress, setProgress] = useState(0);
  const [sending, setSending] = useState(false);
  const SendBulk = async (items) => {
    const ids = items.map((x) => x.id);
    setSending(true);
    setProgress(0);
    await fetch(`${API_BASE}email/sendbulk`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ids),
    });
    // Start polling progress
    const interval = setInterval(async () => {
      const res = await fetch(`${API_BASE}email/progress`);
      const data = await res.json();
      setProgress(data.progress);
      if (data.status === "completed" || data.progress >= 100) {
        clearInterval(interval);
        setSending(false);
      }
    }, 2000);
  };
	return (
<main id="AlldatatblListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Mailer Data List"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="sm:col-12 comp-grid" >
                </div>
                <div className="col-fixed " >
                    <Link to={`/alldatatbl/add`}>
                        <Button label="Add New" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('sent_total', options)}  apiPath="components_data/sent_total_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by Sent Total"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown  className="w-full" onChange={(e) => setFilterValue( 'sent_total', e.value)} value={filters.sent_total.value} optionLabel="label" optionValue="value" options={filters.sent_total.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('templeteid', options)}  apiPath="components_data/templeteid_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'templeteid', e.value)} value={filters.templeteid.value} optionLabel="label" optionValue="value" options={filters.templeteid.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="card  sp-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('states', options)}  apiPath="components_data/states_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by States"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'states', e.value)} value={filters.states.value} optionLabel="label" optionValue="value" options={filters.states.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="">
                            <div className="m-3 p-3 border-round surface-card shadow-2">
                                <Button
                                label="Send Selected"
                                icon="pi pi-send"
                                className="p-button-success mb-3"
                                onClick={() => SendBulk(selectedItems)}
                                disabled={sending}
                                />
                                {sending && (
                                <div>
                                    <ProgressBar value={progress} showValue={true}></ProgressBar>
                                    <p className="mt-2 text-sm text-gray-600">
                                    Sending emails... {progress}%
                                    </p>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="id" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="id" header="Id" body={IdTemplate}  ></Column>
                                    <Column  field="business_name" header="Business Name"   ></Column>
                                    <Column  field="email" header="Email" body={EmailTemplate}  ></Column>
                                    <Column  field="templeteid" header="Templeteid"   ></Column>
                                    <Column  field="sent_total" header="Sent Total"   ></Column>
                                    <Column  field="mobile" header="Mobile"   ></Column>
                                    <Column  field="states" header="States"   ></Column>
                                    <Column  field="pincode" header="Pincode"   ></Column>
                                    <Column headerStyle={{width: 'auto'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                        <div className="">
                            {/* 👇 Toast must be inside the render tree */}
                            <Toast ref={toast} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
AlldatatblListPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'alldatatbl',
	apiPath: 'alldatatbl/index',
	routeName: 'alldatatbllist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 25,
}
export default AlldatatblListPage;
